module.exports = __webpack_public_path__ + "img/s_preview_dy.656f5be1.png";